import React, { FC, PropsWithChildren } from "react";
import { Dialog, DialogActionProps } from "react-toolbox/lib/dialog";

import { IntegrationList, IntegrationListProps } from "./IntegrationList";

export interface IntegrationsListDialogProps extends IntegrationListProps {
    /**
     * Dialog is active
     */
    active?: boolean;
    /**
     * List of integrations to show.
     */
    integrations: string[];
    /**
     * User cancelled the dialog
     */
    onCancel?(): void;
}

export const IntegrationsListDialog: FC<PropsWithChildren<IntegrationsListDialogProps>> = (
    props: IntegrationsListDialogProps
) => {
    const { active, integrations, onCancel } = props;

    const dialogActions: DialogActionProps[] = [
        {
            accent: true,
            label: "Done",
            onClick: onCancel,
        },
    ];

    return (
        <>
            <Dialog title="Add Integration" active={active} actions={dialogActions}>
                <IntegrationList
                    {...props}
                    limitIntegrations={integrations}
                    onboardingMode={true}
                />
            </Dialog>
        </>
    );
};
